import React, {
  FC,
} from 'react';
import { FaChevronLeft } from 'react-icons/fa6';
import SquadSemiBoldText from '../../../../../../../../components/Text/SquadSemiBoldText';
import PingFangMediumText from '../../../../../../../../components/Text/PingFangMediumText';
import QuestionIcon from '../QuestionIcon';
import ColumnCenter from '../../../../../../../../components/Layout/ColumnCenter';
import Button from '../../../../../../../../components/Button';
import Row from '../../../../../../../../components/Layout/Row';

const Title: FC<Props> = ({
  isEnglish,
  showQuestion,
  setShowQuestion,
  onClose,
}) => {
  return (
    <ColumnCenter style={{ marginTop: '25px' }}>
      {/* 返回箭头 */}
      <Button
        style={{ position: 'absolute', left: '15px' }}
        onClick={() => onClose()}
      >
        <FaChevronLeft style={{ fontSize: '20px', color: '#11202B' }} />
      </Button>
      <Row>
        {
          isEnglish ? (
            <SquadSemiBoldText fontSize={26}>
              Select cubicle size
            </SquadSemiBoldText>
          ) : (
            <PingFangMediumText fontSize={26}>
              选择智能柜尺寸
            </PingFangMediumText>
          )
        }
        <QuestionIcon
          isEnglish={isEnglish}
          showQuestion={showQuestion}
          setShowQuestion={setShowQuestion}
        />
      </Row>
    </ColumnCenter>
  );
};

export interface Props {
  isEnglish: boolean;
  showQuestion: boolean;
  setShowQuestion: (show: boolean) => void;
  onClose: () => void;
}

export default Title;
